"use client"

import { Head } from "@inertiajs/react"

import { DestinationStatusBadge } from "@/components/admin/onwards/destination-badges"
import {
  type DestinationDetail,
  DestinationForm,
} from "@/components/admin/onwards/destination-form"
import { DashboardLayout } from "@/layouts/dashboard-layout"

interface Props {
  destination: DestinationDetail
  statuses: string[]
}

export default function EditDestination({ destination, statuses }: Props) {
  return (
    <DashboardLayout>
      <Head title={`Edit ${destination.name}`} />
      <main className="mx-auto flex w-full max-w-2xl flex-col gap-8 px-4 pt-8 pb-12 lg:px-8">
        <header className="flex items-center justify-between gap-4">
          <div className="flex flex-col gap-0.5">
            <h1 className="text-primary font-display md:text-display-xs text-xl font-semibold">
              {destination.name}
            </h1>
            <p className="text-md text-tertiary">{destination.key}</p>
          </div>
          <DestinationStatusBadge status={destination.status} />
        </header>

        <DestinationForm
          mode="edit"
          kind={destination.kind}
          statuses={statuses}
          initial={destination}
        />
      </main>
    </DashboardLayout>
  )
}
